import axios from "axios";
import { SERVER } from "./SERVER";
import { TIMEOUT } from "./TIMEOUT";

class ProjectDataService {
    getAll(token) {
        axios.defaults.headers.common["Authorization"] = "Token " + token;
        return axios.get(`${SERVER}/api/projects/`, { timeout: TIMEOUT });
    }
    getAllServices(token) {
        axios.defaults.headers.common["Authorization"] = "Token " + token;
        return axios.get(`${SERVER}/api/services/`, { timeout: TIMEOUT });
    }
    getAllHSEs(token) {
        axios.defaults.headers.common["Authorization"] = "Token " + token;
        return axios.get(`${SERVER}/api/hses/`, { timeout: TIMEOUT });
    }
    get(number, token) {
        axios.defaults.headers.common["Authorization"] = "Token " + token;
        return axios.get(`${SERVER}/api/project/service/hse/${number}`, {
            timeout: TIMEOUT,
        });
    }
    createProject(data, token) {
        axios.defaults.headers.common["Authorization"] = "Token " + token;
        return axios.post(`${SERVER}/api/create/project/`, data);
    }
    updateProject(id, data, token) {
        axios.defaults.headers.common["Authorization"] = "Token " + token;
        return axios.put(`${SERVER}/api/project/${id}`, data);
    }
    deleteProject(id, token) {
        axios.defaults.headers.common["Authorization"] = "Token " + token;
        return axios.delete(`${SERVER}/api/project/${id}`);
    }

    searchProjects(query, token) {
        axios.defaults.headers.common["Authorization"] = "Token " + token;
        return axios.get(`${SERVER}/api/projects/search/lookup/?q=${query}`, {
            timeout: TIMEOUT,
        });
    }

    searchServices(query, token) {
        axios.defaults.headers.common["Authorization"] = "Token " + token;
        return axios.get(`${SERVER}/api/services/search/lookup/?q=${query}`, {
            timeout: TIMEOUT,
        });
    }

    searchHSEs(query, token) {
        axios.defaults.headers.common["Authorization"] = "Token " + token;
        return axios.get(`${SERVER}/api/hses/search/lookup/?q=${query}`, {
            timeout: TIMEOUT,
        });
    }
}

export default new ProjectDataService();
